module.exports = __webpack_public_path__ + "static/img/lv2.90470543.png";